const CanceledProducts = () => {
  return (
    <div>
      <h3>Отмененные товары</h3>
      <p>Список отмененных позиций.</p>
    </div>
  );
};

export default CanceledProducts;
